import React, { useState, useEffect } from 'react'
import './ApplierServices.css'
import { FaCheck } from "react-icons/fa6";
import img1 from '../../assets/about.png'

function ApplierServices() {
  const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsResponsive(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className='container'>
      <section className='applierServices'>
        {isResponsive ? (
          <>
            <div className='left-applierServices'>
              <div className='our-applierServices'>
                <h2>الخدمات التي نقدمها للباحثين عن فرصة عمل</h2>
                <div className='title__line'></div>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    توفير فرص عمل مناسبة لكل شخص علي حسب خبراته و مؤهلاته.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الداتافلو و حجز امتحان البرومتريك للتخصصات الطبية.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الحصول على التأشيرات من القنصليات المختلفة.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الزيارات(التجارية - العائلية - الشخصية).
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    تصديق جميع المؤهلات و الشهادات(ميلاد - زواج - إلخ....) من القنصليات المختلفة.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الاستقدام.
                  </span>
                </p>
              </div>
            </div>
            <div className='right-applierServices'>
              <img src={img1} alt='' />
            </div>
          </>
        ) : (
          <>
            <div className='right-applierServices'>
              <img src={img1} alt='' />
            </div>
            <div className='left-applierServices'>
              <div className='our-applierServices'>
                <h2>الخدمات التي نقدمها للباحثين عن فرصة عمل</h2>
                <div className='title__line'></div>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    توفير فرص عمل مناسبة لكل شخص علي حسب خبراته و مؤهلاته.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الداتافلو و حجز امتحان البرومتريك للتخصصات الطبية.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الحصول على التأشيرات من القنصليات المختلفة.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الزيارات(التجارية - العائلية - الشخصية).
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    تصديق جميع المؤهلات و الشهادات(ميلاد - زواج - إلخ....) من القنصليات المختلفة.
                  </span>
                </p>
                <p>
                  <FaCheck className='check-icon' />
                  <span>
                    إنهاء إجراءات الاستقدام.
                  </span>
                </p>
              </div>
            </div>
          </>

        )}

      </section>
    </div>


  )
}

export default ApplierServices
